export const EditorTheme = {
  // Editor Canvas Classes
  editorClass:
    "studio-editor-canvas tiptap-editor-canvas pr-4 pl-4 focus:outline-none min-h-[500px]",

  // Node Specific Classes
  table: "studio-editor-table",
  cell: "studio-editor-cell",
  header: "studio-editor-header",
  image: "studio-editor-image",

  // Typography
  h1: "text-3xl font-bold mt-6 mb-4",
  h2: "text-2xl font-bold mt-5 mb-3",
  h3: "text-xl font-semibold mt-4 mb-2",
  paragraph: "leading-relaxed",
  link: "studio-link",

  // UI States
  isProseMirror: "ProseMirror",
  isFocused: "ProseMirror-focused",

  // Colors
  secondaryColor: "#C5785C", // Matches text-secondary in our theme
};
